<template>
  <v-row class="mb-4">
    <v-col>
      <!-- don't v-for because focus will break -->
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input0"
        :value="code.input0"
        :rules="[requiredNumberCheck]"
        @input="(val) => updateCode(0, val)"
        @keyup="toNextInput(1)"
        hide-details
        outlined
        required
      />
    </v-col>
    <v-col>
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input1"
        :rules="[requiredNumberCheck]"
        :value="code.input1"
        @input="(val) => updateCode(1, val)"
        @keyup="toNextInput(2)"
        hide-details
        outlined
        required
      />
    </v-col>
    <v-col>
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input2"
        :rules="[requiredNumberCheck]"
        :value="code.input2"
        @input="(val) => updateCode(2, val)"
        @keyup="toNextInput(3)"
        hide-details
        outlined
        required
      />
    </v-col>
    <v-col>
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input3"
        :rules="[requiredNumberCheck]"
        :value="code.input3"
        @input="(val) => updateCode(3, val)"
        @keyup="toNextInput(0)"
        hide-details
        outlined
        required
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SMSInput",
  methods: {
    focusInput(index) {
      this.$refs[`input${index}`].focus();
    },
    reFocusIfNoCodeValues(code) {
      Object.values(code).every((input) => !input) && this.focusInput(0);
    },
    requiredNumberCheck(value) {
      return !!value && !isNaN(value);
    },
    toNextInput(input) {
      input && this.code[`input${input - 1}`] && this.focusInput(input);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.focusInput(0);
    });
  },
  props: {
    code: Object,
    updateCode: Function,
  },
  watch: {
    code: {
      handler(code) {
        this.reFocusIfNoCodeValues(code);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
.v-text-field >>> input {
  /*font-size: 1.75rem;*/
  font-size: 1.5rem;
}
</style>
